<template>
    <main class="container_conceptiondesktop" id="conceptionDesktop">
        <!--  section left-->
        <secction class="container_conceptiondesktop__section_left">
            <article class="container_conceptiondesktop__section_left__article">
                <!-- aside top -->
                <aside class="container_conceptiondesktop__section_left__article__aside_top">
                    <div class="container_conceptiondesktop__section_left__article__aside_top__div">
                        <img src="@/assets/modification.jpg" alt="Conception"
                            class="container_conceptiondesktop__section_left__article__aside_top__div__img">
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_conceptiondesktop__section_left__article__aside_bottom">
                    <div class="container_conceptiondesktop__section_left__article__aside_bottom__div_text">
                        <p class="container_conceptiondesktop__section_left__article__aside_bottom__div_text__p">
                            Conception de produits industriels, mais également d'assemblages. Je suis en mesure
                            d'effectuer des simulations de résistances des matériaux, ainsi que d'autres simulations.
                        </p>
                    </div>
                    <div class="container_conceptiondesktop__section_left__article__aside_bottom__div_link">
                        <a href="https://fr.wikipedia.org/wiki/wordpress"
                            class="container_conceptiondesktop__section_left__article__aside_bottom__div_link__a">
                            <p class="container_conceptiondesktop__section_left__article__aside_bottom__div_link__a__p">
                                wikipédia
                            </p>
                        </a>
                    </div>
                </aside>
            </article>
        </secction>
        <!-- ############## -->
        <!-- section middle -->
        <!-- ############## -->
        <secction class="container_conceptiondesktop__section_middle">
            <!-- article top -->
            <article class="container_conceptiondesktop__section_middle__article_top">
                <aside class="container_conceptiondesktop__section_middle__article_top__aside">
                    <!-- div vide -->
                    <div class="container_conceptiondesktop__section_middle__article_top__aside__div_vide_1">

                    </div>

                    <!-- div titre -->
                    <div class="container_conceptiondesktop__section_middle__article_top__aside__div_titre">
                        <h1 class="container_conceptiondesktop__section_middle__article_top__aside__div_titre__h1">
                            Conception
                        </h1>
                    </div>

                    <!-- div vide -->
                    <div class="container_conceptiondesktop__section_middle__article_top__aside__div_vide_2">

                    </div>

                </aside>
            </article>
            <!-- ############## -->
            <!-- Article middle -->
            <!-- ############## -->
            <article class="container_conceptiondesktop__section_middle__article_middle w3-container">
                <aside id="id01" class="container_conceptiondesktop__section_middle__article_middle__aside w3-modal ">
                    <!-- div options -->
                    <div
                        class="w3-modal-content container_conceptiondesktop__section_middle__article_middle__aside__div_option">
                        <div
                            class="w3-container container_conceptiondesktop__section_middle__article_middle__aside__div_option__div">
                            <span onclick="document.getElementById('id01').style.display='none'"
                                class="w3-button w3-display-topright container_conceptiondesktop__section_middle__article_middle__aside__div_option__div__span">&times;</span>
                            <h1
                                class="container_conceptiondesktop__section_middle__article_middle__aside__div_option__div__h1">
                                Options
                            </h1>
                            <p class="container_conceptiondesktop__section_middle__article_middle__aside__div_option__div__p">
                                - 300€ maquette sans animation ( adobe XD )<br />
                                - 600€ maquette avec animations ( 2 modifications gratuites )<br />
                                - 200€ la modifications et 100€ par jours de retard ( du client au sujet de la
                                modifications maquette )<br />
                                - 200€ l'hébergement web<br />
                                - 2 000€ déplacement ( en France )( voir CGV pour plus d'information )<br />
                                - Maintenance 280€ l'ajout<br />
                                - Devis 100€<br />
                            </p>
                        </div>
                    </div>
                </aside>
            </article>
            <!-- ############## -->
            <!-- Article bottom -->
            <!-- ############## -->
            <article class="container_conceptiondesktop__section_middle__article_bottom">
                <!-- précédent -->
                <aside class="container_conceptiondesktop__section_middle__article_bottom__aside_back">
                    <div class="container_conceptiondesktop__section_middle__article_bottom__aside_back__div">
                        <button class="container_conceptiondesktop__section_middle__article_bottom__aside_back__div__button">
                            <router-link
                                class="container_conceptiondesktop__section_middle__article_bottom__aside_back__div__button__router-link"
                                to="/rendu-realiste">
                                <div
                                    class="container_conceptiondesktop__section_middle__article_bottom__aside_back__div__button__router-link__div_1">

                                </div>
                                <!--  -->
                                <div
                                    class="container_conceptiondesktop__section_middle__article_bottom__aside_back__div__button__router-link__div_2">

                                </div>
                            </router-link>
                        </button>
                    </div>
                </aside>
                <!-- suivant -->
                <aside class="container_conceptiondesktop__section_middle__article_bottom__aside_next">
                    <div class="container_conceptiondesktop__section_middle__article_bottom__aside_next__div">
                        <button class="container_conceptiondesktop__section_middle__article_bottom__aside_next__div__button">
                            <router-link
                                class="container_conceptiondesktop__section_middle__article_bottom__aside_next__div__button__router-link"
                                to="/mise-en-plan">
                                <div
                                    class="container_conceptiondesktop__section_middle__article_bottom__aside_next__div__button__router-link__div_1">

                                </div>
                                <!--  -->
                                <div
                                    class="container_conceptiondesktop__section_middle__article_bottom__aside_next__div__button__router-link__div_2">

                                </div>
                            </router-link>
                        </button>
                    </div>
                </aside>
            </article>
        </secction>
        <!-- ############## -->
        <!-- section right -->
        <!-- ############## -->
        <secction class="container_conceptiondesktop__section_right">
            <article class="container_conceptiondesktop__section_right__article">
                <aside class="container_conceptiondesktop__section_right__article__aside_top">
                    <div class="container_conceptiondesktop__section_right__article__aside_top__div">
                        <h1 class="container_conceptiondesktop__section_right__article__aside_top__div__h1">
                            Tarifs
                        </h1>
                    </div>
                </aside>
                <!--  -->
                <aside class="container_conceptiondesktop__section_right__article__aside_middle">
                    <!-- div text -->
                    <div class="container_conceptiondesktop__section_right__article__aside_middle__div_text">
                        <p class="container_conceptiondesktop__section_right__article__aside_middle__div_text__p_top">
                            - Pièce simple : 1050 € <br>
                            - Ensemble : 280 €/j <br>
                            - Réalisation rapide <br>
                        </p>
                        <!-- prix -->
                        <p class="container_conceptiondesktop__section_right__article__aside_middle__div_text__p_bottom">
                            Prix total : 1 700 €
                        </p>
                    </div>
                </aside>
                <!-- aside bottom button -->
                <aside class="container_conceptiondesktop__section_right__article__aside_bottom">
                    <div class="container_conceptiondesktop__section_right__article__aside_bottom__div_left">
                        <router-link
                            class="container_conceptiondesktop__section_right__article__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_conceptiondesktop__section_right__article__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                    <div class="container_conceptiondesktop__section_right__article__aside_bottom__div_right">
                        <button onclick="document.getElementById('id01').style.display='block'"
                            class="container_conceptiondesktop__section_right__article__aside_bottom__div_right__button">
                            <div
                                class="container_conceptiondesktop__section_right__article__aside_bottom__div_right__button__div_1">

                            </div>
                            <!--  -->
                            <div
                                class="container_conceptiondesktop__section_right__article__aside_bottom__div_right__button__div_2">

                            </div>
                        </button>
                    </div>
                </aside>
            </article>
        </secction>
    </main>
</template>

<script >
export default {
    name: 'ConceptionDesktop',
}
</script>

<style  lang=scss>
@import "@/style/components/Services//Conception/ConceptionDesktop.scss";

@media screen and(max-width: 926px) {
    #conceptionDesktop {
        display: none;
    }
}
</style>